<script setup>
import { useClientType } from '@/composables/useClientType';

/**
 * smartwel 시트 공용 래퍼.
 * - 모바일(isMobileUi): 하단 바텀시트 (slideUp) + 상단 드래그 핸들
 * - PC: 중앙 팝업 모달 (scaleIn)
 * - backdrop 클릭 시 close. 컨텐츠는 기본 슬롯.
 */
const { isMobileUi } = useClientType();

defineProps({
  maxWidth: { type: String, default: '400px' },
});

const emit = defineEmits(['close']);
</script>

<template>
  <div class="srs-backdrop" @click="emit('close')" />
  <div
    class="srs-sheet"
    :class="isMobileUi ? 'srs-sheet--mobile' : 'srs-sheet--pc'"
    :style="!isMobileUi ? { maxWidth } : undefined"
    @click.stop
  >
    <div v-if="isMobileUi" class="srs-handle" />
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.srs-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: rgba(0, 0, 0, 0.5);
  animation: srs-fade 0.2s ease-out;
}

.srs-sheet {
  position: fixed;
  z-index: 1101;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.srs-sheet--mobile {
  left: 0;
  right: 0;
  bottom: 0;
  max-height: 90vh;
  border-radius: 16px 16px 0 0;
  padding-bottom: var(--safe-area-bottom, 0px);
  animation: srs-slide-up 0.25s ease-out;
}

.srs-sheet--pc {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 48px);
  max-height: 86vh;
  padding: 8px 0 0;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  animation: srs-scale-in 0.22s ease-out;
}

.srs-handle {
  width: 36px;
  height: 4px;
  background: #d1d5db;
  border-radius: 100px;
  margin: 10px auto 4px;
  flex-shrink: 0;
}

@keyframes srs-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes srs-slide-up {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes srs-scale-in {
  from {
    transform: translate(-50%, -50%) scale(0.94);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}
</style>
